import { createPortal } from 'react-dom';
import { HeaderModal } from './HeaderModal';
import styles from './Modal.module.css';
import { usePreventBodyScroll } from '@/component/Modal/ModalThin';

export function Modal(props) {
  const { children } = props;
  usePreventBodyScroll();
  return createPortal(
    <div
      className="relative z-20 modal-step"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto h-[100dvh]">
        <div className={styles.modalContainer}>
          <div className={styles.modal}>
            <HeaderModal />
            {children}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
